module.exports = __webpack_public_path__ + "static/media/assign class teacher.93c89c8c.svg";